import getGatsbyImageObject from './getGatsbyImageObject';

export default function getProperImageData(localData, urlData) {
  if (!localData) return urlData;

  return getGatsbyImageObject(localData) || urlData;
}
